/* import __COLOCATED_TEMPLATE__ from './phone-number-table.hbs'; */
/* RESPONSIBLE TEAM: team-phone */
import Component from '@glimmer/component';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

interface Args {
  label: string;
  data: any[];
  columns: any[];
  totalPrice: number;
}
interface Signature {
  Args: Args;
}
export default class PhoneNumberTable extends Component<Signature> {
  formattedPhoneNumber(phoneNumber: string) {
    return parsePhoneNumberFromString(phoneNumber)?.formatInternational();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Billing::Usage::Phone::PhoneNumberTable': typeof PhoneNumberTable;
    'billing/usage/phone/phone-number-table': typeof PhoneNumberTable;
  }
}
